import React, { useEffect, useRef, useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import "./QiraHomeChat.css";

export default function QiraHomeChat() {
  const [open, setOpen] = useState(false);
  const [showCallout, setShowCallout] = useState(false);
  const [messages, setMessages] = useState([
    {
      role: "assistant",
      content:
        "Ciao, sono Qira 👋 Posso aiutarti a capire come QrMenu può adattarsi al tuo locale: menu QR, ordini dal tavolo, cucina, sala, AI o asporto con OTP.",
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);

useEffect(() => {
  const calloutClosed =
    sessionStorage.getItem("qiraHomeCalloutClosed") === "1";

  if (!calloutClosed) {
    const timer = setTimeout(() => {
      setShowCallout(true);
    }, 6000);

    return () => clearTimeout(timer);
  }
}, []);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading, open]);

  const openChat = () => {
  setOpen(true);
  setShowCallout(false);
  sessionStorage.setItem("qiraHomeCalloutClosed", "1");
};

const closeCallout = (e) => {
  e.stopPropagation();
  setShowCallout(false);
  sessionStorage.setItem("qiraHomeCalloutClosed", "1");
};

  const closeChat = () => {
    setOpen(false);
    sessionStorage.setItem("qiraHomeClosed", "1");
  };

  const sendMessage = async (forcedText) => {
   const text = String(forcedText || input || "").trim();
    if (!text || loading) return;

    const historySnapshot = [...messages];

    setMessages((prev) => [...prev, { role: "user", content: text }]);
    setInput("");
    setLoading(true);

    try {
      const functions = getFunctions(undefined, "europe-west1");
      const fn = httpsCallable(functions, "askQiraHomeAssistant");

      const res = await fn({
        messaggio: text,
        history: historySnapshot,
      });

      const risposta =
        res?.data?.risposta ||
        "Mi spiace, non sono riuscita a rispondere in questo momento.";

      setMessages((prev) => [...prev, { role: "assistant", content: risposta }]);
    } catch (err) {
      console.error("Errore Qira:", err);
      setMessages((prev) => [
        ...prev,
        {
          role: "assistant",
          content:
            "Mi spiace, in questo momento non riesco a rispondere. Riprova tra poco.",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
{!open && (
  <>
    {showCallout && (
      <div
        className="qira-callout"
        onClick={openChat}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            openChat();
          }
        }}
      >
        <div className="qira-callout-avatar">
          Q
          <span className="qira-callout-online" />
        </div>

        <div className="qira-callout-content">
          <strong>Ciao! Sono Qira 👋</strong>
          <span>Hai qualche domanda su QrMenu?</span>
          <span>Chiedimi pure!</span>
        </div>

        <button
          className="qira-callout-close"
          onClick={closeCallout}
          aria-label="Chiudi messaggio Qira"
        >
          ×
        </button>
      </div>
    )}

    <button
      className="qira-bubble"
      onClick={openChat}
      aria-label="Apri chat con Qira"
    >
      <span className="qira-bubble-avatar">✨</span>
      <span className="qira-bubble-text">Chiedi a Qira</span>
    </button>
  </>
)}

      {open && (
        <div className="qira-chat">
          <div className="qira-chat-header">
            <div className="qira-chat-title">
              <div className="qira-avatar">
                Q
                <span className="qira-online" />
              </div>
              <div>
                <div className="qira-name">Qira</div>
                <div className="qira-subtitle">
                  Consulente AI QrMenu Italia
                </div>
              </div>
            </div>

            <button
              className="qira-close"
              onClick={closeChat}
              aria-label="Chiudi Qira"
            >
              ×
            </button>
          </div>

          <div className="qira-messages">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`qira-message ${
                  msg.role === "user" ? "user" : "assistant"
                }`}
              >
                {msg.content.split("\n").map((line, idx, arr) => (
                  <span key={idx}>
                    {line}
                    {idx < arr.length - 1 && <br />}
                  </span>
                ))}
              </div>
            ))}

            {messages.length === 1 && (
              <div className="qira-quick-actions">
                <button onClick={() => sendMessage("Ho una pizzeria, come potrebbe aiutarmi QrMenu?")}>
                  Ho una pizzeria
                </button>
                <button onClick={() => sendMessage("Vorrei capire gli ordini dal tavolo")}>
                  Ordini dal tavolo
                </button>
                <button onClick={() => sendMessage("Mi interessa l'asporto con OTP")}>
                  Asporto con OTP
                </button>
              </div>
            )}

            {loading && (
              <div className="qira-typing">
                <span />
                <span />
                <span />
                Qira sta scrivendo...
              </div>
            )}

            <div ref={endRef} />
          </div>

          <div className="qira-input-area">
            <input
              value={input}
              placeholder="Chiedi qualcosa su QrMenu..."
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  sendMessage();
                }
              }}
            />
            <button onClick={() => sendMessage()} disabled={loading || !input.trim()}>
              {loading ? "..." : "Invia"}
            </button>
          </div>
        </div>
      )}
    </>
  );
}